export enum TypeAResults {
  SPARK = '1ee8fe8c-af62-49e8-b63e-a4d9538916b1',
  MONSTERS = 'e11b320b-3801-454a-9e8c-975e783b5fc4',
  BUSY = 'e7f71c60-5b84-4647-b402-411097425aff',
  SCARED = '4a1f175d-c095-431f-9ad3-ee105569870f',
}
